import { ReactElement } from 'react';
import { Tabs as AntTabs, TabsProps } from 'antd';
import { SCustomize } from './Tabs.style';

export const Tabs = ({ rootClassName, ...restProps }: TabsProps): ReactElement => (
  <SCustomize>
    <AntTabs rootClassName={[rootClassName, 'custom-ant-tabs'].join(' ')} {...restProps} />
  </SCustomize>
);
